import React, { useEffect, useState } from 'react';
import { useTwitterContext } from '../TwitterContext';
import { useAuth0 } from '@auth0/auth0-react';
import UserInfo from './UserInfo';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-regular-svg-icons';

const PostTweet = () => {
  const [tweet, setTweet] = useState('');
  const [ imgURL, setImgURL ] = useState('');
  const [ user, setUser ] = useState(null);
  const { accessToken, curUser, updateTweetList } = useTwitterContext();
  const { loginWithRedirect } = useAuth0();
  const [ showImgField, setShowImgField ] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    if (e.target.value.length > 280) {
      alert("Tweet is too long!");
      return;
    }
    setTweet(e.target.value);
  };

  const handleSubmit = (e) => {
    if (tweet.length === 0) {
      alert("Tweet is empty!");
      return;
    }
    e.preventDefault();
    // Add logic to post the tweet
    postTweet();
    setTweet('');
  };

  const handleImgURLChange = (e) => {
    setImgURL(e.target.value);
  }

  async function postTweet() {
    // make a call to our API to verify the user in our database, if it doesn't exist we'll insert it into our database
    // if not log in, then log in
    if (curUser === null) {
      loginWithRedirect();
      return;
    }
    // finally we'll redirect the user to the /app route
    const data = await fetch(`${process.env.REACT_APP_API_URL}/tweets`, {
      method: "POST",
      body: JSON.stringify({ "text": tweet, "userId": curUser.id, "img": imgURL }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // go to profile page
    navigate(`/profile/${curUser.id}`);
    updateTweetList();
  }

  useEffect(() => {
    setUser(curUser);
  }, [curUser]);

  const ShowImgField = () => {
    setShowImgField(!showImgField);
  }

  if (user === null) {
    return null;
  }
  return (
    <div className="post-tweet" >
      <UserInfo info={user}/>
      <form onSubmit={handleSubmit}>
        <textarea
          value={tweet}
          onChange={handleInputChange}
          placeholder="What's on your mind?"
        />
        {imgURL && <img className="tweet-image" src={imgURL} alt="Preview"/>}
        {showImgField && 
        <input type="string" placeholder="Image URL" onChange={handleImgURLChange} className="post-tweet-icon-input"/>}
        <div className="post-tweet-submit">
          <FontAwesomeIcon icon={faImage} className="post-tweet-icon" onClick={ShowImgField}/>
          <button type="submit" alt="post">Post</button>
        </div>
      </form>
    </div>
  );
};

export default PostTweet;
